import { sensorConstants } from "../../constants/client";

export const sensor = {
  listing,
  listingSuccess,
  listingFailure,
};

function listing(payload) {
  return { type: sensorConstants.LISTING_REQUEST,  payload };
}

function listingSuccess(payload) {
  return { type: sensorConstants.LISTING_SUCCESS, payload };
}

function listingFailure(error) {
  return { type: sensorConstants.LISTING_FAILURE, error };
}